export const urlFormatSearchKeyword = (searchKeyword: string) => {
  return searchKeyword.split('/').join('_').replace(/ /g, '-')
}

export const addSearchQuery = (queryString: string, searchQuery: string) => {
  if (searchQuery.length >= 3) {
    return queryString
      ? `${queryString}&search=${urlFormatSearchKeyword(searchQuery)}`
      : `?search=${urlFormatSearchKeyword(searchQuery)}`
  }

  return queryString
}

export const updateURL = (queryString: string, defaultSlug: string) => {
  if (queryString !== null && typeof window !== `undefined`) {
    if (queryString === '') {
      history.pushState(null, '', defaultSlug)
    } else {
      history.pushState(null, '', queryString)
    }
  }
}

export const urlIsMatch = (url: string) => {
  try {
    let convertedURL = url.indexOf('http') !== 0 ? new URL(url, location.origin) : new URL(url)
    return convertedURL.pathname === location.pathname
  } catch (err) {
    return false
  }
}
